import { Component, OnInit } from '@angular/core';
import { LocalStorageKey } from '@ddt-web/generic-utils';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-wealth-web-debug-banner',
	templateUrl: './wealth-web-debug-banner.component.html',
	styleUrls: ['./wealth-web-debug-banner.component.scss']
})
export class WealthWebDebugBannerComponent implements OnInit {
	private parsedUrl: URL;
	public usingMockAPI: boolean;
	public mockApiButtonText: string;

	public ngOnInit(): void {
		this.parsedUrl = new URL(window.location.href);

		this.usingMockAPI = Boolean(localStorage.getItem(LocalStorageKey.MockWealthWeb));
		this.mockApiButtonText = this.usingMockAPI ? 'Unmock APIs' : 'Mock APIs';
	}

	public toggleMockAPIs(): void {
		this.mockApiButtonText = this.usingMockAPI ? 'Mock APIs' : 'Unmock APIs';
		this.toggleButtons(this.usingMockAPI, 'mockWealthWeb');
	}

	private toggleButtons(flag: boolean, localStorageKey: string): void {
		if (!flag) {
			localStorage.setItem(localStorageKey, 'true');
		} else {
			localStorage.removeItem(localStorageKey);
		}
		this.parsedUrl.searchParams.delete('mockWealthWeb');
		window.location.assign(this.parsedUrl.href);
	}
}
